const storageKey = 'corecry:desktop-page-scroll'
const positions = new Map()
let loaded = false
let saveTimer

function load() {
    if (loaded) return
    loaded = true
    try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]')
        if (Array.isArray(saved)) {
            for (const entry of saved.slice(-100)) {
                if (Array.isArray(entry) && typeof entry[0] === 'string' && Number.isFinite(entry[1])) positions.set(entry[0], entry[1])
            }
        }
    } catch { /* Storage is optional. */ }
}

function key() {
    const state = window.history.state
    return typeof state?.position === 'number' && typeof state.current === 'string' ? `${state.position}:${state.current}` : null
}

function save() {
    clearTimeout(saveTimer)
    try { sessionStorage.setItem(storageKey, JSON.stringify([...positions])) } catch { /* Storage is optional. */ }
}

export function rememberDesktopPageScroll(element) {
    const current = key()
    if (!current) return
    load()
    positions.delete(current)
    positions.set(current, Math.max(0, element.scrollTop))
    if (positions.size > 100) positions.delete(positions.keys().next().value)
    clearTimeout(saveTimer)
    saveTimer = setTimeout(save, 200)
}

export function restoreDesktopPageScroll(to, from, savedPosition) {
    const element = document.querySelector('.desktop-content-scroll')
    if (!window.__CORECRY_DESKTOP__ || !element) return false
    load()
    const current = key()
    if (savedPosition || !from.name) element.scrollTo({ top: positions.get(current) ?? 0, behavior: 'instant' })
    else if (to.path !== from.path) element.scrollTo({ top: 0, behavior: 'instant' })
    return true
}

export function flushDesktopPageScroll() { save() }
